import type { FaireProductEntity } from "../../entity_types/product";

export const p_tgrmr99575: FaireProductEntity = {
  token: "p_tgrmr99575",
  type: "product",
  name: "FLORAL PRINTED Sweatshort/Sweatshirt Matching Set",
  brandToken: "b_ebyk25ji57",
  brandName: "OAT COLLECTIVE",
  imageUrl:
    "https://cdn.faire.com/fastly/295e7ab880ab72f965bbfb16bda7851c886a0d0f47a27185f8d5f99c5e674495.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ecb8100bedbf2467bb2d7919b7859b9938aa7878c3bda4601a02fe06509620bf.jpeg",
    "https://cdn.faire.com/fastly/445408dea3fc6ed395b704b247bb811242228131482b3daab363d01235626a9a.jpeg",
    "https://cdn.faire.com/fastly/c786feec3c43f8dd64c29b2574c69c8ec0eb46b0f3fe63c51577a7d71e07ab04.jpeg",
    "https://cdn.faire.com/fastly/46f5593f2eadaffcc19145cbff5216e831396b0b04d16b0b8aa14d43a715fb7f.jpeg",
    "https://cdn.faire.com/fastly/699599d9c60b5076fb35d5052414fee1e39cabfd243283ad455409128565eff9.jpeg",
    "https://cdn.faire.com/fastly/595d19e92aff232302667fdcbc968e98e3745dacc5bca135cf9bc2ce969ba67b.jpeg",
  ],
  priceDollars: 47,
  description:
    "FLORAL PRINTED Sweatshort/Sweatshirt Matching Set Mid length Graphic Fleece Pullover Relaxed Fit With adjustable/elastic waist short Set.\n\nLimited Quantity! These are In-stock ready to ship!\n\n\nThis is sold as a two piece Set.\n\n\nDetails for Top:\n\n-Same Sponge Soft fleece as our Exclusive Oat sweatshirts\n\n-Mid Length \n\n-Fold-able Longer Sleeve Length\n\n-Comfortable Boxy Fit\n\n-Spun from plush sponge fleece fabric\n\n-Remarkably soft pullover\n\n-Featuring ribbed cuffs and waistband, a crew neck\n\n-Exclusive Oat Collective Label and Design\n\n-Oat Collective Hang Tag\n\nDetails for Shorts:\n\n\n-Same Sponge Soft fleece as our Exclusive Oat sweatshirts\n\n-Relaxed Comfortable Fit\n\n-Elastic waistband \n\n-Side Pockets\n\n-Side Slits\n\n-Inner Hidden Twill draw-cord for adjustable Waist\n\n-Remarkably Soft Fleece \n\n-Oat Collective Hang Tag\n",
  tags: [],
  msrpDollars: 84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:12.830Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
